import { createTheme } from "@mui/material/styles";

export let theme = createTheme({
  // Theme customization goes here as usual, including tonalOffset and/or
  // contrastThreshold as the augmentColor() function relies on these
});

theme = createTheme(theme, {
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#324b4e', // Fokusfarbe
          '&.Mui-focused': {
              color: '#324b4e', // Fokusfarbe
          },
        }
      }
    },
  },
  // Custom colors created with augmentColor go here
  palette: {
    baeren: theme.palette.augmentColor({
      color: {
        main: '#4b949c',
      },
      name: 'baeren',
    }),
    baerendark: theme.palette.augmentColor({
      color: {
        main: '#324b4e',
      },
      name: 'baerendark',
    }),
    baerenlight: theme.palette.augmentColor({
      color: {
        main: '#94b0b3',
      },
      name: 'baerenlight',
    }),
    baerengruen: theme.palette.augmentColor({
      color: {
        main: '#57bf80',
      },
      name: 'baerengruen',
    }),

  },
});

export let themeClock = createTheme({
  // Theme customization goes here as usual, including tonalOffset and/or
  // contrastThreshold as the augmentColor() function relies on these
});

themeClock = createTheme(themeClock, {
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#324b4e', // Rahmenfarbe
            },
            '&:hover fieldset': {
              borderColor: '#324b4e', // Hover-Rahmenfarbe
            },
            '&.Mui-focused fieldset': {
              borderColor: '#324b4e', // Fokusfarbe
            },
          },
          '& .MuiInputLabel-root': {
            color: '#324b4e', // Label-Farbe
            '&.Mui-focused': {
              color: '#324b4e !important', // Hintergrundfarbe für ausgewählten Tag
            },            
          },
        },
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          '&.Mui-selected': {
            backgroundColor: '#324b4e !important', // Hintergrundfarbe
          },
        },
      },
    },    
    MuiPickersDay: {
      styleOverrides: {
        root: {
          color: '#324b4e', // Farbe der Tage
          '&.Mui-selected': {
            backgroundColor: '#324b4e !important', // Hintergrundfarbe für ausgewählten Tag
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#324b4e', // Farbe der Tage
          '&.Mui-selected': {
            backgroundColor: '#324b4e !important', // Hintergrundfarbe für ausgewählten Tag
          },
        },
      },
    },    
    MuiClockPointer: {
      styleOverrides: {
        root: {
          backgroundColor: '#324b4e', // Uhrzeiger-Farbe
        },
        thumb: {
          border: '16px solid #324b4e'
        },
      },
    },
    MuiClock: {
      styleOverrides: {
        pin: {
          backgroundColor: '#324b4e', // Uhrzeiger-Farbe
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#324b4e', // Uhrzeiger-Farbe
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: '#324b4e', // Uhrzeiger-Farbe
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: '#324b4e', // Uhrzeiger-Farbe
        },
      },
    },
  },
  // Custom colors created with augmentColor go here
  palette: {
    baeren: theme.palette.augmentColor({
      color: {
        main: '#4b949c',
      },
      name: 'baeren',
    }),
    baerendark: theme.palette.augmentColor({
      color: {
        main: '#324b4e',
      },
      name: 'baerendark',
    }),
    baerenlight: theme.palette.augmentColor({
      color: {
        main: '#94b0b3',
      },
      name: 'baerenlight',
    }),
    baerengruen: theme.palette.augmentColor({
      color: {
        main: '#57bf80',
      },
      name: 'baerengruen',
    }),

  },
});